/* eslint-disable no-shadow */
import router from '../../router/index'
import { store } from '../store'
import { orderApi } from '../../services/ApiServices/orderApi'

const state = {
	buyNowProduct: [],
	buyNowCount: 0,
	buyNowTotal: 0,
	buyNowItemTotal: 0,
	buyNowOffer: 0
}

const getters = {
	getBuyNowProduct: state => state.buyNowProduct,
	getBuyNowProductCount: state => state.buyNowCount,
	getBuyNowTotal: state => state.buyNowTotal,
	getBuyNowItemTotal: state => state.buyNowItemTotal,
	getBuyNowOffer: state => state.buyNowOffer,
	// getGiftCardOffer: state => state.giftCardOffer.subtotal,
	getOrderBuyNowProduct: (state) => {
		const orderCart = []
		state.buyNowProduct.forEach((payload) => {
			const a = {}
			a.product_id = payload.product_id
			a.vendor_id = payload.vendor_id
			a.quantity = payload.quantity
			a.price = payload.price
			if (payload.promotion_id) {
				a.promotion_id = payload.promotion_id
				a.price = payload.promotion_applied_price
			}
			orderCart.push(a)
		})
		return orderCart
	}
}

export function updateBuyNowProperties (state) {
	let total = 0
	let itemTotal = 0
	let offers = 0
	const productsInCart = state.buyNowProduct
	productsInCart.forEach((product) => {
		if (product.promotion_applied_price) {
			total += product.quantity *
        product.promotion_applied_price
			itemTotal += product.quantity *
        product.promotion_applied_price
			offers += product.quantity *
        (product.price - product.promotion_applied_price)
		} else {
			total += product.quantity * product.price
			itemTotal += product.quantity * product.price
		}
	})
	if (store.state.user.giftCardAmount && store.state.user.giftCardAmount.subtotal) {
		total -= store.state.user.giftCardAmount.subtotal
	}
	if (store.state.user.coinRedeemValue && store.state.user.coinRedeemValue.coinValue) {
		total -= store.state.user.coinRedeemValue.coinValue
	}
	total += store.getters['charges/getShippingCharge'] * state.buyNowCount + store.getters['charges/getTaxCharge'] * state.buyNowCount
	// Vue.nextTick(() => {
	if (router.currentRoute.path === '/checkout') {
		if (store.state.user.promoCode && store.state.user.promoCode.discount_price) {
			if (total > store.state.user.promoCode.discount_price) {
				total -= store.state.user.promoCode.discount_price
				// Vue.toasted.show('Coupon Code Applied Successfully');
			} else {
				total = 0
				if (state.buyNowProduct.length > 0) {
					store.dispatch('siteData/setPaymentGatewayIdData', '')
					orderApi.orderCharge()
						.then((res) => {
							router.push({
								path: '/order-success',
								query: {
									order_number: store.getters['user/getOrderData'].order_number,
									payment_mode: 'card'
								}
							})
						})
				}
				// store.state.user.promoCode = '';
				// Vue.toasted.show('Cart Amount Should be Greater than Coupon Amount');
			}
		}
	}
	state.buyNowCount =
      productsInCart.length > 0 ? productsInCart.map(product => parseInt(product.quantity, 10)).reduce((prev, next) => prev + next) : 0
	state.buyNowTotal = total
	state.buyNowItemTotal = itemTotal
	state.buyNowOffer = offers
	store.state.order.amountToPay = total
	// })
}

const mutations = {
	mutateAddToBuyNow: (state, payload) => {
		payload.timestamp = new Date().getTime()
		state.buyNowProduct = []
		state.buyNowProduct.push(payload)
		updateBuyNowProperties(state)
	},
	mutateDeleteFromBuyNow: (state) => {
		state.buyNowProduct = []
		updateBuyNowProperties(state)
	},
	mutateBuyNowQuantity: (state) => {
		updateBuyNowProperties(state)
	},
	mutateupdateGiftCardQuantity: (state) => {
		updateBuyNowProperties(state)
	},
	mutateUpdateCoinAmount: (state) => {
		updateBuyNowProperties(state)
	},
	setGiftOfferDataMutation: (state, payload) => {
		state.giftCardOffer = payload
	}
}

const actions = {
	addToBuyNow: ({
		commit
	}, payload) => {
		commit('mutateAddToBuyNow', payload)
	},
	deleteFromBuyNow: ({
		commit
	}) => {
		commit('mutateDeleteFromBuyNow')
	},
	updateBuyNowQuantity: ({
		commit
	}) => {
		commit('mutateBuyNowQuantity')
	},
	updateGiftCardQuantity: ({
		commit
	}) => {
		commit('mutateupdateGiftCardQuantity')
	},
	updateCoinAmount: ({
		commit
	}) => {
		commit('mutateUpdateCoinAmount')
	},
	setGiftOfferData: ({
		commit
	}, payload) => {
		commit('setGiftOfferDataMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
